import { render, staticRenderFns } from "./MonitObserveTable.vue?vue&type=template&id=2744fdfd&"
import script from "./MonitObserveTable.vue?vue&type=script&lang=js&"
export * from "./MonitObserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports